import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import { AddonsTypes } from '../../helpers';

import styles from './TimelineAddOnCard.Styles';

function TimelineAddOnCard({
  images,
  width,
  height,
  left,
  top,
  fullWidth,
  type,
  addOn,
  theme,
  currency,
  onItemPress,
}) {
  const fullWidthStyle = () => {
    if (fullWidth) {
      return styles.fullWidth(type, theme);
    }
    return {};
  };

  const { id, icon, name, price } = addOn;

  const handleOnItemPress = _id => {
    _isFunction(onItemPress) && _id !== 'my_plan_id_0' && onItemPress(addOn);
  };

  const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

  return (
    <View
      style={[
        styles.cardContainer(type),
        styles.cardPosition(width, height, top, left, fullWidth, type, theme),
        fullWidth && styles.cardShadow,
        fullWidthStyle(),
      ]}
    >
      <TouchableWithoutFeedback onPress={() => handleOnItemPress(id)}>
        <View style={styles.card}>
          <View
            style={[
              styles.iconWrapper(type, theme, fullWidth, width),
              !fullWidth && styles.cardShadow,
            ]}
          >
            <Icon name={images[icon]} type="image" style={styles.icon} size={24} />
          </View>
          <View style={styles.textWrapper}>
            <VFText style={styles.name} i18nKey={name} />
            <VFText
              style={styles.price(theme)}
              i18nKey={`${currencyTransformer(price, 0)}${currency}`}
            />
          </View>
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
}
TimelineAddOnCard.defaultProps = {
  theme: LightThemeColors,
  currency: '€',
  type: AddonsTypes.ACTIVE,
  onItemPress: () => {},
};
TimelineAddOnCard.propTypes = {
  images: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  left: PropTypes.number,
  top: PropTypes.number,
  currency: PropTypes.string,
  fullWidth: PropTypes.bool,
  onItemPress: PropTypes.func,
  type: PropTypes.string,
  addOn: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    price: PropTypes.number,
  }),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default withTheme(TimelineAddOnCard);
